module.exports = __webpack_public_path__ + "static/IMG_1193-1679d8e8b03ade78b970a18d4891b145.jpg";